// Shared spacing/sizing  for calendar cell content.
// Each cell type may still have its own visual differences (border, bg, etc),
// but padding/sizing should come from here so cells stay visually consistent.
export const cellPadding = 'px-5 py-2';
export const cellText = 'text-sm';
export const cellBase = `${cellPadding} ${cellText} w-full rounded-md`;
